module.exports = __webpack_public_path__ + "img/1.d7068c81.png";